export const GB_FEATURES = {
  EXP_GOODBOT_INQUIRY_ENGAGEMENT: 'exp_goodbot_inquiry_engagement',
  EXP_PUPPY_PAGE: 'exp_puppy_page',
  EXP_RESULTS_CTA: 'exp_results_cta',
  EXP_PUPPY_CARD_TRANSPORT: 'exp_puppy_card_transport',
  EXP_PUPPY_CARD_REDESIGN_MOBILE: 'exp_puppy_card_redesign_mobile'
};
